export const EventTypeInfo = {
  custom: {
    key: "custom",
    label: "Custom",
    textColor: "black",
    backendLabel: "manual",
  },
  recommended: {
    key: "recommended",
    label: "Recommended",
    textColor: "white",
    backendLabel: "recommendation",
  },
  block: {
    key: "block",
    label: "Blocked",
    textColor: "black",
    backendLabel: "block",
  },
  deleted: {
    key: "deleted",
    label: "Deleted",
    textColor: "black",
    backendLabel: "deleted",
  },
  default: {
    key: "default",
    label: "Default",
    textColor: "black",
    backendLabel: "default",
  },
  approved: {
    key: "approved",
    label: "Applied",
    textColor: "white",
    backendLabel: "approved",
  },
  auto_resize: {
    key: "auto_resize",
    label: "Auto Resize",
    textColor: "white",
    backendLabel: "auto_resize",
  },
  backoff: {
    key: "backoff",
    label: "Backoff",
    textColor: "white",
    backendLabel: "backoff",
  },
};

export const LEGEND_ITEMS = [
  { label: "Recommended", color: "#E9F2FF" },
  { label: "Recommended & Applied", color: "#247EFE" },
  { label: "Custom", color: "#FFEBE5" },
  { label: "Custom & Applied", color: "#E38E00" },
  { label: "Expired", color: "#8390A3" },
  { label: "Blocked", color: "#FEE8E7" },
] as const;

export enum ScheduleStatus {
  Pending = "pending",
  Approved = "approved",
  Rejected = "rejected",
}

export const WarehouseScheduleOpportunity = "warehouse_schedule_recommendation";

export const WarehouseScheduleRecurrenceEndDate = "2100-01-01T00:00:00.000Z";

export const GET_SCHEDULED_OPPORTUNITY_DATA = "GET_SCHEDULED_OPPORTUNITY_DATA";
